/*
* @Author: tengmaoqing
* @Date:   2018-06-27 11:17:18
* @Last Modified by:   tengmaoqing
* @Last Modified time: 2018-06-27 11:35:21
*/

// pid config 相关

export const LOGIN_METHOD = {
  PWD: 'pwd',
  CODE: 'code'
};

export const PLATFORM = {
  WeChat: 1,
  mini_program: 2,
  Alipay: 3,
  ATM: 4,
  H5: 5,
  Android: 6,
  iOS: 7
};



// WEBPACK FOOTER //
// ./src/system/const/config.js